import { useNavigate } from "react-router";
import { Button, PageHeader, PageShell, icons } from "@bruntworkwear-apps/ui";
import { ConnectionStatus } from "./components/ConnectionStatus";

/**
 * The Overview route: who you are signed in as, and the settings a run will
 * use.
 */
export function OverviewModule() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageHeader
        title="Accounting Inventory"
        description="Customs and landing-cost reconciliation for the month-end close."
        action={
          <Button
            leadingIcon={<icons.Upload size={16} />}
            onClick={() => void navigate("/run")}
          >
            Start a run
          </Button>
        }
      />
      <ConnectionStatus />
    </PageShell>
  );
}
